// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  box-sizing: border-box;
  position: fixed;
  height: 136px;
  width: 328px;
  top: 40%;
  left: 40%;
  background: var(--cBranco);
  border: 2px solid var(--pLaranja);
  border-radius: 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  padding: 30px;
  color: var(--cDark);
  box-shadow: 0 0 0 50vmax rgba(0, 0, 0, 0.5);
}

.modal-rascunho {
  box-sizing: border-box;
  position: fixed;
  height: 136px;
  width: 328px;
  top: 40%;
  left: 40%;
  background: var(--cBranco);
  border: 2px solid var(--pLaranja);
  border-radius: 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  padding: 40px;
  color: var(--cDark);
  box-shadow: 0 0 0 50vmax rgba(0, 0, 0, 0.5);
}

.modal-voltar {
  box-sizing: border-box;
  position: fixed;
  height: 156px;
  width: 328px;
  top: 40%;
  left: 40%;
  background: var(--cBranco);
  border: 2px solid var(--pLaranja);
  border-radius: 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  padding: 30px;
  color: var(--cDark);
  box-shadow: 0 0 0 50vmax rgba(0, 0, 0, 0.5);
}

.button-left {
  padding-right: 5px;
}

.button-right {
  padding-left: 5px;
}

.footer {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

button:focus {
  border: none;
}

a:focus {
  border: none;
}

.teste {
  z-index: 10000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,YAAY;EAEZ,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,YAAY;EAEZ,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,YAAY;EAEZ,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".modal {\n  box-sizing: border-box;\n  position: fixed;\n  height: 136px;\n  width: 328px;\n  border-radius: 16px;\n  top: 40%;\n  left: 40%;\n  background: var(--cBranco);\n  border: 2px solid var(--pLaranja);\n  border-radius: 16px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  text-align: center;\n  padding: 30px;\n  color: var(--cDark);\n  box-shadow: 0 0 0 50vmax rgba(0, 0, 0, 0.5);\n}\n\n.modal-rascunho {\n  box-sizing: border-box;\n  position: fixed;\n  height: 136px;\n  width: 328px;\n  border-radius: 16px;\n  top: 40%;\n  left: 40%;\n  background: var(--cBranco);\n  border: 2px solid var(--pLaranja);\n  border-radius: 16px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  text-align: center;\n  padding: 40px;\n  color: var(--cDark);\n  box-shadow: 0 0 0 50vmax rgba(0, 0, 0, 0.5);\n}\n\n.modal-voltar {\n  box-sizing: border-box;\n  position: fixed;\n  height: 156px;\n  width: 328px;\n  border-radius: 16px;\n  top: 40%;\n  left: 40%;\n  background: var(--cBranco);\n  border: 2px solid var(--pLaranja);\n  border-radius: 16px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  text-align: center;\n  padding: 30px;\n  color: var(--cDark);\n  box-shadow: 0 0 0 50vmax rgba(0, 0, 0, 0.5);\n}\n\n.button-left {\n  padding-right: 5px;\n}\n\n.button-right {\n  padding-left: 5px;\n}\n\n.footer {\n  display: flex;\n  justify-content: center;\n  padding-top: 20px;\n}\n\nbutton:focus {\n  border: none;\n}\n\na:focus {\n  border: none;\n}\n\n.teste {\n  z-index: 10000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
